import Axios from "axios";

const state = {
  cars: [],
  carsLoaded: false,
  carImage: "",
  imgLoaded: false
};

const getters = {
  getCars: state => state.cars,
  getCarByKey: state => key => {
    return window._.find(state.cars, c => {
      return c.key.toLowerCase() === key.toLowerCase();
    });
  },
  carsLoaded: state => state.carsLoaded,
  carImage: state => state.carImage,
  imgLoaded: state => state.imgLoaded
};

const actions = {
  /**
   * @description Get cars from API
   *
   * @param {*} { commit }
   */
  loadCars({ commit }) {
    //eslint-disable-next-line
    let url = CONF.apiUrl;
    Axios.get(url + "v2/cars")
      .then(r => {
        commit("fetchCars", r.data);
      })
      .catch(e => window.console.error(e));
  },
  /**
   * @description Get current car image
   *
   * @param {*} { commit }
   * @param {string} key
   */
  getImageUrl({ commit }, key) {
    let id = "";
    Axios.get(
      location.protocol +
        "//cardb.toyota-europe.com/1/country/FI/language/FI/brand/toyota/model/" +
        key +
        "/cars"
    )
      .then(r => {
        id = r.data.Cars[0].ID;
        let image =
          location.protocol +
          "//images.toyota-europe.com/fi/vehicle/" +
          key +
          "/" +
          id +
          "/exterior-0.png";
        commit("setCarImage", image);
      })
      .catch(e => window.console.error(e));
  },
  /**
   * @description Set car image loaded status
   *
   * @param {*} { commit }
   */
  setImageLoaded({ commit }) {
    commit("setImageLoaded");
  }
};

const mutations = {
  /**
   * @description Set cars to store
   *
   * @param {Object} state
   * @param {Object} cars
   */
  fetchCars(state, cars) {
    state.cars = cars;
    state.carsLoaded = true;
  },
  /**
   * @description Set car image to store
   *
   * @param {Object} state
   * @param {Object} image
   */
  setCarImage(state, image) {
    state.carImage = image;
  },
  /**
   * @description Clear car image from store
   *
   * @param {Object} state
   */
  clearCarImage(state) {
    state.carImage = "";
    state.imgLoaded = false;
  },
  /**
   * @description Set image loaded state
   *
   * @param {Object} state
   */
  setImageLoaded(state) {
    state.imgLoaded = true;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
